import styled, { css } from "styled-components";

export const StyledCheckboxWrapper = styled.div`
  padding: 12px 0;

  ${({ error }) =>
    error &&
    css`
      > div:not(:first-child) > label > span.checkmark {
        border-color: ${({ theme }) => theme.colors.offTrackText};
        box-shadow: 0 0 20px 0px ${({ theme }) => theme.colors.offTrackText};
      }
    `}

  > span.error {
    display: block;
    height: 12px;
    ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
    color: ${({ theme }) => theme.colors.offTrackText};
    padding-top: 4px;
    padding-bottom: 4px;
  }
`;
